import React from "react";

import Form from "./main";

import { connect } from "react-redux";

import {
    CACHE_SERVICE,
    CACHE_SPECIALIZATION,
    CACHE_LANGUAGE,
    CACHE_LANGUAGE_PAIR,
    CACHE_COUNTRY,
    CACHE_CURRENCY,
    CACHE_UNIT,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getServicesForSelect,
    getServicesById,
    getCategoriesById,
    getSpecializationsForSelect,
    getCurrenciesForSelect,
    getCountriesForSelect,
    getLanguagesForSelect,
    getLanguagesById,
    getLanguagePairsForSelect,
    getUnitsForSelect,
    getUnitsById,
    getLanguagePairsById,
} from "../../../redux/actions/cache/interface";

import Loader from "../../../components/loader";

class Container extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadCache();
    }

    render() {
        const { loading, loaded, alta } = this.props;

        return (
            <>
                <Loader loading={loading} />
                {!loading && loaded && <Form {...this.props} />}
            </>
        );
    }
}

const cacheList = [
    CACHE_SERVICE,
    CACHE_SPECIALIZATION,
    CACHE_LANGUAGE,
    CACHE_LANGUAGE_PAIR,
    CACHE_COUNTRY,
    CACHE_CURRENCY,
    CACHE_UNIT,
];

function MapStateToProps(state) {
    return {
        loading: isCacheLoading(state, cacheList),
        loaded: isCacheLoaded(state, cacheList),

        countries: getCountriesForSelect(state),
        currencies: getCurrenciesForSelect(state),
        specializations: getSpecializationsForSelect(state),
        languagePairs: getLanguagePairsForSelect(state),
        languagePairsById: getLanguagePairsById(state),
        languages: getLanguagesForSelect(state),
        languagesById: getLanguagesById(state),
        units: getUnitsForSelect(state),
        unitsById: getUnitsById(state),

        services: getServicesForSelect(state),
        servicesById: getServicesById(state),
        categoriesById: getCategoriesById(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
